<template>
  <Sheet>
    <div
      class="px-5 pt-2 pb-3 text-[16px] font-medium leading-[20px] text-gray-800"
    >
      Filter by
    </div>
    <div class="h-px w-full shrink-0 bg-[#efefef]" />

    <Sheet.Body class="px-0!">
      <div
        v-for="category in categories"
        :key="category.value"
        class="flex h-[44px] cursor-pointer items-center justify-between px-5"
        @click="toggle(category.value)"
      >
        <span class="text-[16px] leading-[20px] text-gray-800">
          {{ category.label }}
        </span>
        <Checkbox
          :model-value="state[category.value]"
          class="pointer-events-none"
        />
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Sheet, Checkbox } from '@dacr/library'
import { FileCategory } from '@/shared/graphql/legacy/generated'

const props = defineProps<{
  initialState: Record<FileCategory, boolean>
  onChange: (state: Record<FileCategory, boolean>) => void
}>()

const categories = [
  { label: 'Images', value: FileCategory.Images },
  { label: 'Video', value: FileCategory.Videos },
  { label: 'Audio', value: FileCategory.Audio },
  { label: 'Documents', value: FileCategory.Documents },
  { label: 'Code', value: FileCategory.Code },
  { label: 'Other', value: FileCategory.Other },
]

const state = ref<Record<FileCategory, boolean>>({ ...props.initialState })

const toggle = (value: FileCategory) => {
  state.value[value] = !state.value[value]
  props.onChange({ ...state.value })
}
</script>
